export default {
    invoiceState: {
        tag: 'span',
        className: {
            '0': 'text-info',
            '1': 'text-success',
            '2': 'text-primary',
        }
    }
}